import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';

import { J4uV1Service, ICouponModel, CouponModel } from "abs-ngx-library/src/lib/core";
import {Observable, of} from "rxjs";
import { map } from 'rxjs/operators';


@Injectable()
export class GridService {
    private defaultNoResultsMsg: string = 'No coupons available.';
    public window: any = window;
    private HTTP_OPTIONS = {headers: new HttpHeaders(this.window['AB']?.j4uHttpOptions)};
    public couponSource: any;

    public constructor(private _j4uService: J4uV1Service) {
    }

    public getData(carouselLimitItems?: number, couponGridType?: string, freshPassCouponEventListener?: string[], isBonusPath: boolean = false): Observable<any>{
        let obsrData = of([]);
        switch (couponGridType) {
            case 'instant-allocation':
                obsrData = this._j4uService.getData(carouselLimitItems, true);
                this.couponSource = this._j4uService.isDataCached ? "local storage" : "direct call api";
                break;
            case 'couponsdeals':
                obsrData = this._j4uService.getData(carouselLimitItems, false, isBonusPath);
                this.couponSource = this._j4uService.isDataCached ? "local storage" : "direct call api";
                break;
            case 'hiddenevents':
                if (this.window['AB']['COMMON'].authorize()) {
                    if (this.window['AB']['COMMON'].getURLParameterByName('eventId') != null && this.window['AB']['COMMON'].getURLParameterByName('eventId') != '') {
                        let eventId = decodeURIComponent(<string>this.window['AB']['COMMON'].getURLParameterByName('eventId'));
                        let storeId = this.window['AB'].userInfo.j4u.storeId;
                        obsrData = this._j4uService.getRemoteData(this.window['AB'].hiddenEventsPath + "eventId=" + eventId + "&storeId=" + storeId + "&_deletedAttribute=true", this.HTTP_OPTIONS, carouselLimitItems,false, true);
                    }else {
                       obsrData = of([]);
                    }
                }
                break;
                case 'freshpassevents':
                    if (freshPassCouponEventListener && freshPassCouponEventListener.length > 0) {
                        obsrData = this._j4uService.getData(carouselLimitItems, false).pipe(
                            map((data: any) => {
                                return data.filter((coupon: any) => {
                                    if (coupon.events && coupon.events.length > 0) {
                                        return coupon.events.some((event: string) => freshPassCouponEventListener.includes(event.toLowerCase()))
                                    }
                                    return false
                                })
                            })
                        );
                        this.couponSource = this._j4uService.isDataCached ? "local storage" : "direct call api";
                    }
                    break;
            case 'custom':
                //TODO: TBD
                break;
            default:
                obsrData = of([]);
                break;
        }

        return obsrData;
    }

    public getNoResultsMsg() {
        const couponGridPage = this.window['AB']['couponGridPage'];
        let results;
        switch (couponGridPage) {
            case 'shelf-page':
            case 'promo':
            case 'rewardcard':
            case 'bogo':
            case 'historylastorder':
            case 'historylist':
                results = this.window['AB']['errorText'] || this.defaultNoResultsMsg;
                break;
            case 'q':
                results = "<div class='no-result'><div class=container'><dl><dd>Check for typos.</dd><dd>Be more general (e.g. \"carrots\" instead of \"bags of carrots\")</dd><dd>Try looking within the aisles shown below</dd></dl></div></div>";
                break;
            default:
                results = '<span>No items are available.</span>';
                break;
        }
        return results;
    }


    public areAllCouponsUnavailable(coupons: ICouponModel) {
        let isUnavailable = true;
        if (!Array.isArray(coupons)) {
            return false;
        }
        coupons.forEach((coupon) => {
            if (coupon) {
                isUnavailable = false;
            }
        });
        return isUnavailable;
    }

    public getInfiniteScrollType(): string {
        if (this.window['AB']['infiniteScroll'] != undefined && this.window['AB']['infiniteScroll'] != '') {
            return (this.window['AB']['infiniteScroll'] == 'client') ? 'client' : 'server';
        } else
            return 'none';
    }

    /**
     * Creates filter data structure from coupon data
     * Extracts unique categories, events, and offer types from coupons
     */
    public createFilterDataObject(baseCoupons: any[]) {
        const TOP_CATEGORY_ITEM = 'Special Offers';
        
        // Extract and sort unique categories
        const categories: any = [
            ...new Set(baseCoupons.map((category: any) => category.category)),
        ].sort((a: any, b: any) => {
            if (a === TOP_CATEGORY_ITEM) return -1;
            if (b === TOP_CATEGORY_ITEM) return 1;
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        });
        
        // Extract and sort unique events
        const events = [
            ...new Set([...baseCoupons.map((coupon: any) => coupon.events).flat()]),
        ].sort((a: any, b: any) => (a < b ? -1 : a > b ? 1 : 0));
        
        // Extract and sort unique offer types
        const offerTypes = [
            ...new Set([...baseCoupons.map((coupon: any) => coupon.offerType)]),
        ].sort((a: any, b: any) => (a < b ? -1 : a > b ? 1 : 0));
        
        // Map offer types to display names
        const couponTypes = this.window['SWY'].CONFIGSERVICE.nimbusConfig.filterCouponTypes;
        const newOfferTypes: any = [];
        offerTypes.forEach((ct) => newOfferTypes.push(couponTypes[ct]));

        const filtersData = [
            {
                property: 'category',
                label: 'Category',
                values: categories.map((category: string) => ({ name: category })),
                displaySpacer: true
            },
            {
                property: 'events',
                label: 'Events',
                values: events.map((e: string) => ({ name: e })),
                displaySpacer: true
            },
            {
                property: 'offer-type',
                label: 'Offer Type',
                values: newOfferTypes.map((ot: string) => ({ name: ot })),
                displaySpacer: true
            },
        ];
        
        return {
            data: filtersData,
            showClearAllFilters: true,
            showCount: false,
            displayLimitedFilter: false
        };
    }
}

